
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiCameraOn as ObiCameraOnElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-camera-on.js';
 
 
 

 
 export const ObiCameraOn = createComponent({
   react: React,
   tagName: 'obi-camera-on',
   elementClass: ObiCameraOnElement,
   events: {
     
   }
  });
 
 